import { z } from 'zod';

export const WizardStep = {
    POSITION_DETAILS: 'POSITION_DETAILS',
    TALENT_INSIGHTS: 'TALENT_INSIGHTS',
    JOB_DESCRIPTION: 'JOB_DESCRIPTION',
    PREVIEW_SUBMIT: 'PREVIEW_SUBMIT',
};

export const formSchema = z.object({
    jobTitle: z.string().min(1, 'Position title is required'),
    department: z.string().min(1, 'Position category is required'),
    minYearsExp: z.number().min(0).max(99, 'Minimum years of experience must be cant be more than 99'),
    maxYearsExp: z.number().min(0).max(99, 'Maximum years of experience must be cant be more than 99'),
    location: z.object({
        id: z.string(),
        label: z.string(),
    }),
    hiringManager: z.object({
        id: z.string(),
        label: z.string(),
    }),
    bandLevel: z.string(),
    desiredStartDate: z.date(),
    description: z.string(),
    budgetLowerLimit: z.coerce.number(),
    budgetMidLimit: z.coerce.number(),
    budgetUpperLimit: z.coerce.number(),
    mandatorySkills: z.array(z.string()).refine((val) => val.length > 0, 'Mandatory skills are required'),
    optionalSkills: z.array(z.string()),
    jobType: z.enum(['standard', 'generic']),
    employmentType: z.enum(['full-time', 'part-time', 'contract']),
    aitemplates: z.array(z.string()).optional(),
});
